import cardImg from "../assets/images/desktopbg.png";
import netimg from "../assets/images/netflix.png";
import tempimg from "../assets/images/temp.png";
import muidesktop from "../assets/images/mui-d.png";
import reydesk from "../assets/images/rey-d.png";
import wsp from "../assets/images/wsp.png";
import coviddesk from "../assets/images/covid-d.png";
import instadesk from "../assets/images/insta-desk.png";
import edesk from "../assets/images/e-desk.png";
import pizzaImg from "../assets/images/pizzaShop.png";
import builtImg from "../assets/images/built.png";
import iroImg from "../assets/images/iro.webp";
import blanqeaseImg from "../assets/images/blanqease.png";
import dineo from "../assets/images/dineo.png";
import amalImg from "../assets/images/Amalitech.png"
import ayoImg from "../assets/images/ayotech.png"
import astraImg from "../assets/images/astra.png"
import dishImg from "../assets/images/dishplug.png"

export const webdetailsdata = [
  {
    key: 13,
    title: "Blanqease",
    cardImg: blanqeaseImg,
    url: "https://www.blanqease.com/",
    tools: ["NextJs", "TypeScript", "Tailwindcss", "Arkesel"],
  },
  {
    key: 14,
    title: "Iro",
    cardImg: iroImg,
    url: "https://iro-ecru.vercel.app/",
    tools: ["NextJs", "TypeScript", "Tailwindcss", "Xata", "Typeforms"],
  },
  {
    key: 11,
    title: "Pizza Shop",
    cardImg: pizzaImg,
    url: "https://pizza-shop-alpha.vercel.app/",
    tools: ["ReactJs", "TypeScript", "Material UI icons", "sass"],
  },
  {
    key: 12,
    title: "BuiltGhana Company",
    cardImg: builtImg,
    url: "https://built.africa/gh",
    tools: ["NextJs", "Javascript", "Material UI", "css"],
  },
  {
    key: 15,
    title: "DineO",
    cardImg: dineo,
    url: "https://dineo.vercel.app/",
    tools: ["Nextjs", "Tailwindcss"],
  },
  {
    key: 1,
    title: "BDwaste website",
    cardImg: cardImg,
    url: "https://bdwastetech.netlify.app/",
    tools: ["ReactJs", "react-scroll", "Html", "Css"],
  },
  {
    key: 3,
    title: "MUI Template",
    cardImg: muidesktop,
    url: "https://material-ui-web-template.vercel.app/",
    tools: ["material UI", "ReactJs", "SwiperJs"],
  },
  {
    key: 4,
    title: "Reymond Portfolio-Website",
    cardImg: reydesk,
    url: "https://reymonddegbe.netlify.app",
    tools: ["material UI-ICONS", "ReactJs", "Map-gl", "Html", "Css"],
  },
  {
    key: 5,
    title: "Whatsapp Clone",
    cardImg: wsp,
    url: "https://whatsapp-clone-9e790.web.app/",
    tools: ["ReactJs", "Html", "firebase", "Css"],
  },
  {
    key: 6,
    title: "Covid19 Tracker",
    cardImg: coviddesk,
    url: "https://covid19trackerreactweb.netlify.app",
    tools: ["chartjs", "react-chartjs", "leaflet", "react-leaflet", "ReactJS"],
  },
  {
    key: 7,
    title: "Ecommerce website",
    cardImg: edesk,
    url: "https://kwesidev-ecommercweb.herokuapp.com/",
    tools: [
      "ReactJs",
      "Express",
      "NodeJs",
      "axios",
      "react-redux",
      "react-stripe-checkout",
      "styled components",
      "material ui",
      "jwt",
    ],
  },
  {
    key: 8,
    title: "Instagram Clone",
    cardImg: instadesk,
    url: "https://kwesi-devinstagram.herokuapp.com/",
    tools: [
      "ReactJs",
      "Express",
      "NodeJs",
      "axios",
      "react-redux",
      "timeago js",
      "sass",
      "material ui",
      "jwt",
    ],
  },
  {
    key: 9,
    title: "Netflix Clone",
    cardImg: netimg,
    url: "https://kwesi-dev-netflix-clone.herokuapp.com/",
    tools: [
      "ReactJs",
      "Express",
      "NodeJs",
      "axios",
      "timeago js",
      "sass",
      "material ui",
      "jwt",
    ],
  },
  {
    key: 10,
    title: "Typescript React Template",
    cardImg: tempimg,
    url: "https://typescript-website-template.vercel.app/",
    tools: ["ReactJs", "TypeScript", "FontAwesome", "sass", "material ui"],
  },
  {
    key: 20,
    title: "Amalitech Invoice App",
    cardImg: amalImg,
    url: "https://invoice-app-amalitech.vercel.app/",
    tools: ["ReactJs", "TypeScript", "sass"],
  },
  {
    key: 21,
    title: "Ayotech Landing Page",
    cardImg: ayoImg,
    url: "https://ayotech-website-ibhvq1esd-kwesi-dev.vercel.app/",
    tools: ["ReactJs", "TypeScript", "css"],
  },
  {
    key: 22,
    title: "Astrastellar Website",
    cardImg: astraImg,
    url: "https://www.astrastellar.com/",
    tools: ["AstroJs", "TypeScript", "tailwind"],
  },
  {
    key: 24,
    title: "Dishplug Website",
    cardImg: dishImg,
    url: "https://www.dishplug.com/",
    tools: ["NextJs", "TypeScript", "tailwind"],
  },
];
